export default __webpack_public_path__ + "static/media/avatar_whitney5.0b44ade9.mp3";